import React, { useEffect, useMemo, useState } from 'react';
import {
  Form,
  Space,
  Button,
  Drawer,
  Select,
} from '@lockerpm/design';

import SelectedProjects from './SelectedProjects';

import {
} from '@ant-design/icons';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import global from '../../../../../config/global';
import storeActions from '../../../../../store/actions';
import { } from '../../../../../utils/common';

function ExportFormData(props) {
  const {
    visible = false,
    onClose = () => {},
  } = props
  const { t } = useTranslation();
  const projects = useSelector((state) => state.project.projects);
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)
  const progressData = useSelector((state) => state.workspace.progressData)

  const [form] = Form.useForm()
  const [selectedProjectIds, setSelectedProjectIds] = useState(null);

  const format = Form.useWatch('format', form)

  useEffect(() => {
    setSelectedProjectIds(null);
    form.setFieldsValue({
      format: global.constants.FILE_TYPE.JSON,
    })
  }, [visible])

  const handleClose = () => {
    form.resetFields();
    onClose();
  }

  const wsProjects = useMemo(() => {
    if (selectedWorkspace) {
      return projects.filter((p) => p.organization.id == selectedWorkspace.id)
    }
    return []
  }, [projects, selectedWorkspace])

  const selectedProjects = useMemo(() => {
    if (!selectedProjectIds) {
      return [];
    }
    return !selectedProjectIds?.includes('all') && Array.isArray(selectedProjectIds) ? selectedProjectIds.map((id) => wsProjects.find((p) => p.id == id)) : wsProjects;
  }, [selectedProjectIds, wsProjects])

  const handleNext = () => {
    const progressId = progressData.length + 1;
    global.store.dispatch(storeActions.updateProgressData([
      ...progressData,
      {
        id: progressId,
        format: format,
        isExport: true,
        workspaceId: selectedWorkspace.id,
        createdAt: (new Date()).getTime(),
        projects: selectedProjects.map((p) => ({
          ...p,
          pSecrets: [],
          pEnvironments: [],
        }))
      }
    ]))
    handleClose();
  }

  const handleRemove = (projectId) => {
    if (selectedProjectIds.length === 1) {
      setSelectedProjectIds(null)
    } else {
      setSelectedProjectIds(selectedProjects.filter((p) => p.id !== projectId).map((p) => `${p.id}`))
    }
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('import_export.export')}
        placement="right"
        onClose={handleClose}
        open={visible}
        width={480}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!selectedProjectIds}
              onClick={() => handleNext()}
            >
              { t('button.next') } 
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            name={'format'}
            label={
              <p className="font-semibold">{t("import_export.choose_format")}</p>
            }
          >
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
            >
              {global.constants.IMPORT_EXPORT_FILE_TYPES.map((type) => (
                <Select.Option
                  value={type.value}
                  key={type.value}
                >
                  {type.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="mb-0"
            label={
              <p className="font-semibold">{t("import_export.choose_projects")}</p>
            }
          >
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              value={selectedProjectIds}
              allowClear
              mode={!selectedProjectIds || selectedProjectIds === 'all' ? "" : "multiple"}
              onChange={(v) => setSelectedProjectIds(!v ? v : (v.includes('all') ? 'all' : (Array.isArray(v) ? v : [v])))}
            >
              <Select.Option
                value={'all'}
                key={'all'}
              >
                {t('common.all_projects')}
              </Select.Option>
              {wsProjects.map((type) => (
                <Select.Option
                  value={`${type.id}`}
                  key={type.id}
                  disabled={selectedProjectIds === 'all'}
                >
                  {type.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <p>{t('import_export.choose_projects_note')}</p>
          <div className='mt-4'>
            <SelectedProjects
              selectedProjects={selectedProjects}
              onRemove={(id) => handleRemove(id)}
            />
          </div>
        </Form>
      </Drawer>
    </div>
  );
}

export default ExportFormData;
